"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginForm = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const Button_1 = require("../../Button");
const Field_1 = require("../../Form/Field");
const ValidationErrors_1 = require("../../ValidationErrors");
const customErrorsMap_1 = __importDefault(require("./customErrorsMap"));
require("./index.scss");
const className = 'login-form';
class LoginForm extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            formData: this.props.formData,
            focusFieldName: this.props.focusFieldName,
        };
        this.handleFieldChange = (fieldName, event) => {
            const { value } = event.target;
            const updatedData = {
                ...this.state.formData,
                ...{
                    [fieldName]: value,
                },
            };
            this.props.onChange({
                fieldName,
                formData: updatedData,
            });
            this.setState({
                formData: updatedData,
                focusFieldName: fieldName,
            });
        };
        this.handleSubmit = (event) => {
            event.preventDefault();
            this.props.onSubmit(this.state.formData);
        };
        this.handleForgotLink = (event) => {
            event.preventDefault();
            this.props.onForgot();
        };
        this.setFocus = () => {
            var _a, _b, _c;
            if (this.state.focusFieldName !== undefined) {
                (_c = (_b = (_a = this.fieldRefs[this.state.focusFieldName]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus) === null || _c === void 0 ? void 0 : _c.call(_b);
            }
        };
        this.getFormError = (fieldName) => {
            var _a;
            const customMapIfExists = (_a = customErrorsMap_1.default[fieldName]) !== null && _a !== void 0 ? _a : {};
            return (0, ValidationErrors_1.getFormError)(this.props.formErrors, fieldName, customMapIfExists);
        };
        this.fieldRefs = {
            login: react_1.default.createRef(),
            password: react_1.default.createRef(),
        };
    }
    /**
     * Hook on mount component
     */
    componentDidMount() {
        this.setFocus();
    }
    /**
     * Hook on update component
     */
    componentDidUpdate() {
        this.setFocus();
    }
    /**
     * Rendering.
     */
    render() {
        const classNames = (0, classFunctions_1.getClassNames)(className, this.props.modificators);
        const { formData } = this.state;
        const { isSubmitButtonDisabled, } = this.props;
        const { login, password, } = formData;
        return (react_1.default.createElement("form", { className: classNames, onSubmit: this.handleSubmit },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("h3", { className: `${className}__title` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/LoginForm/Title:text', defaultMessage: 'Login' })),
                react_1.default.createElement("div", { className: `${className}__field` },
                    react_1.default.createElement(Field_1.FormField, { autoComplete: 'off', type: 'text', ref: this.fieldRefs.login, value: login, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/LoginForm/Login:label', defaultMessage: 'Email' }), error: this.getFormError('login'), onChange: event => this.handleFieldChange('login', event) })),
                react_1.default.createElement("div", { className: `${className}__field` },
                    react_1.default.createElement(Field_1.FormField, { autoComplete: 'off', type: 'password', ref: this.fieldRefs.password, value: password, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/LoginForm/Password:label', defaultMessage: 'Password' }), error: this.getFormError('password'), onChange: event => this.handleFieldChange('password', event) })),
                react_1.default.createElement("div", { className: `${className}__buttons` },
                    react_1.default.createElement("div", { className: `${className}__forgot` },
                        react_1.default.createElement("a", { href: '', onClick: this.handleForgotLink },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/LoginForm/ForgotPassword:text', defaultMessage: 'Reset password' }))),
                    react_1.default.createElement(Button_1.Button, { type: 'submit', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/LoginForm/Submit:label', defaultMessage: 'Login' }), disabled: isSubmitButtonDisabled })))));
    }
}
exports.LoginForm = LoginForm;
LoginForm.defaultProps = {
    formData: {
        login: '',
        password: '',
    },
    formErrors: {},
    isSubmitButtonDisabled: false,
    focusFieldName: undefined,
    onChange: () => {
    },
    onSubmit: () => {
    },
    onForgot: () => {
    },
};
//# sourceMappingURL=index.js.map